<h1 class="title">Ask me anything about your account</h1>

<button class="close-button" (click)="activeModal.close()"><rkt-icon name="times"></rkt-icon></button>

<div class="rkt-table-search-container">
  <div class="rkt-table-search-label">
    <rkt-icon name="search" class="rkt-table-search-icon rkt-icon"></rkt-icon>
    <input
      type="text"
      class="rkt-input rkt-table-search-input"
      placeholder="Enter your search term..."
      [disabled]="loading"
      [(ngModel)]="searchString"
      (keydown.enter)="getAISearchResults()"
    />
    <button (click)="getAISearchResults()" class="submit-icon" [disabled]="!searchString?.length || loading">
      <rkt-icon name="send" class="rkt-icon"></rkt-icon>
    </button>
  </div>
  <div class="query-div" [hidden]="loading">
    @for (amaQuestion of askMeAnythingQuestions$ | async; track amaQuestion) {
      <div class="query-pill">
        <div class="ama-query-text" (click)="updateSearchString(amaQuestion.queryText)">{{ amaQuestion.queryText }}</div>
        <rkt-icon name="times" class="rkt-value-clear-btn rkt-icon" (click)="deleteFavouriteQuestion(amaQuestion)"></rkt-icon>
      </div>
    }
  </div>
</div>

<div class="natural-language-search-results-container">
  @if (loading) {
    <div class="loading-placeholder"></div>
  } @else {
    @if (searchResults.length || insightSummary) {
      <div class="natural-language-query-container">
        <div class="chat-box query-chat-box">
          <div class="user-icon">{{ (activeUser$ | async)?.initials?.charAt(0) }}</div>
          <div class="question">
            <div class="question-title">You</div>
            <div class="question-content">{{ searchedQuery }}</div>
          </div>
          <div class="user-favorite" (click)="markQuestionAsFavourite(searchedQuery)">
            <rkt-icon name="star" class="star-icon" [class.is-favorite]="isFavouriteQuestion(searchedQuery)"></rkt-icon>
          </div>
        </div>
        @if (insightSummary) {
          <div class="response-container">
            <div class="chat-box">
              <img class="rocket-icon" [src]="brand.logoIcon" [alt]="brand.logoAlt" [title]="brand.logoAlt" />
              <div class="question">
                <div class="question-title">{{ brand.displayName }}</div>
                <div class="question-content" [innerHTML]="insightSummary"></div>
              </div>
            </div>
          </div>
        }
        @if (searchResults.length) {
          <div class="tabular-data">
            <div class="tabular-data-title" (click)="showTableData = !showTableData">
              <div>This response includes data in table format</div>
              <rkt-icon [name]="showTableData ? 'chevron-down' : 'chevron-right'"></rkt-icon>
            </div>
            @if (showTableData) {
              <div class="natural-language-search-results-table">
                <rkt-table
                  [rows]="searchResults"
                  [columns]="columns"
                  [count]="totalElements"
                  [limit]="10"
                  [loadingIndicator]="loading"
                  [messages]="{ emptyMessage: 'No records found.' }"
                  [scrollbarH]="true"
                  dateTimeFormat="MM/dd/yy HH:mm"
                  (rowActivated)="viewEntityDetails($event)"
                  emptyValuePlaceholder="--"
                ></rkt-table>
                @if (maxRecordCountReached) {
                  <div class="max-record-count">A maximum of 200 records has been reached.</div>
                }
                @if (downloadResultEnabled) {
                  <div class="download-csv-btn">
                    <button rktButton btnType="primary" (click)="downloadCSVResult()">Download CSV</button>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    } @else {
      <div class="empty-search-results">
        {{ searchErrorText }}
      </div>
    }
  }
</div>
